import moment from "moment";
import Initial from "../../helpers/Initial";

const Footer = () => {
  return (
    <footer className="footer-wrap">
      <div className="container">
        Powered By: Backrr
        {/* &copy; {moment().format("Y")} Backrr. All Rights Reserved. &nbsp; */}
        {/* <img className="realtime-logo" src={Logos?.Poweredby} alt="realtime" /> */}
      </div>
    </footer>
  );
};

export default Footer;
